<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div>
        <div class="flex flex-wrap">
          <div
            class="w-full text-left px-3 pb-3 text-purple-700 text-2xl font-bold"
          >
            Edición de ficha
          </div>
          <div class="flex flex-col w-full">
            <form
              class="w-full max-w-lg"
              id="levantamientoForm"
              @submit.prevent
            >
              <!-- Formulario de ficha -->
              <div>
                <div class="flex flex-wrap -mx-3 pb-3">
                  <div
                    class="w-full"
                    v-for="(question, index) in questions"
                    :key="'question' + question.id_pregunta"
                  >
                    <!-- pregunta tipo ABIERTA -->
                    <div v-if="question.tipo === 'ABIERTA'"> 
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <textarea
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          :id="'question' + index"
                          type="text"
                          :name="'question' + index"
                          v-model="answers[index].respuesta"
                        />
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
                      </div>
<!--                       <div class="w-full px-3 mb-3">
                        <label class="w-full flex items-center text-gray-900">
                          <input
                            class="mr-2 leading-tight"
                            type="checkbox"
                            v-model="answers[index].sensible"
                          />
                          <span class="text-sm">
                            Contiene información sensible
                          </span>
                        </label>
                      </div> -->
                    </div>
                    <!-- /pregunta tipo ABIERTA -->

                    <!-- pregunta tipo MULTISELECCION -->
                    <div v-if="question.tipo === 'MULTISELECCION'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <template
                          v-for="(option, optIndex) in question.opciones"
                        >
                          <div
                            class="flex items-center text-gray-700 font-bold"
                            :class="
                              optIndex === question.opciones.length - 1 &&
                              !question.otro
                                ? 'mb-3'
                                : ''
                            "
                            :key="'opt' + optIndex"
                          >
                            <input
                              class="mr-2 leading-tight"
                              type="checkbox"
                              v-model="
                                answers[index].respuesta.opciones[option]
                              "
                            />
                            <span class="text-sm">
                              {{ option }}
                            </span>
                          </div>
                        </template>
                        <div
                          v-if="question.otro"
                          class="flex items-center text-gray-700 font-bold mb-3"
                        >
                          <input class="mr-2 leading-tight" type="checkbox" />
                          <span class="text-sm"> Otro </span>
                          <input
                            type="text"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                        </div>

                        <!-- Subpreguntas de la pregunta multiselección -->
                        <template
                        v-for="(subpregunta, subSIndex) in question.subpregunta"
                      >
                        <div
                          class="w-full px-3 mb-6 md:mb-0"
                          :key="'subS' + subSIndex"
                        >
                          <label
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                            :for="'subquestion' + subSIndex"
                            >{{ subpregunta.id_pregunta }}.-
                            {{ subpregunta.texto }}</label
                          >
                          <!-- Subpregunta tipo multiselección->abierta -->
                          <template v-if="subpregunta.tipo === 'ABIERTA'">
                            <textarea
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              :id="'subquestion' + subSIndex"
                              type="text"
                              :name="'subquestion' + subSIndex"
                              v-model="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .respuesta
                              "
                            />
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                          <!-- /Subpregunta tipo multiselección->abierta -->

                          <!-- /Subpregunta tipo multiselección->selección -->
                          <template v-if="subpregunta.tipo === 'SELECCION'">
                            <div class="relative">
                              <select
                                v-model="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].respuesta.selected_answer
                                "
                                :name="'subquestion' + subSIndex"
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              >
                                <option disabled selected>
                                  Seleccione una
                                </option>
                                <template
                                  v-for="(
                                    option, subOIndex
                                  ) in subpregunta.opciones"
                                >
                                  <option
                                    :key="'subO' + subOIndex"
                                    :value="option"
                                  >
                                    {{ option }}
                                  </option>
                                </template>
                                <option v-if="subpregunta.otro==true" value="Otro">
                                  Otro
                                </option>                                
                              </select>
                              
                              <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>

                            <div
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex].respuesta.selected_answer === 'Otro'
                              "
                              class="flex items-center text-gray-700 font-bold mb-3"
                            >
                              <span class="text-sm"> Otro </span>
                              <input
                                type="text"
                                class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                                v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta.otro"
                              />
                            </div>

                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Seleccione la respuesta.
                            </p>
                          </template>
                          <!-- /Subpregunta tipo multiselección->selección -->

                          <!-- Subpregunta tipo multiselección->campos -->
                          <template v-if="subpregunta.tipo === 'CAMPOS'">
                            <template
                              v-for="(
                                campo, subFieldIndex
                              ) in subpregunta.campos"
                            >
                              <template v-if="campo.tipo === 'texto'">
                                <div :key="'subf' + subFieldIndex">
                                  <label
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                    :for="'subquestionField' + subFieldIndex"
                                    >{{ campo.texto }}</label
                                  >
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    :id="'subquestionField' + subFieldIndex"
                                    type="text"
                                    :name="'subquestionField' + subFieldIndex"
                                    v-model="
                                      answers[index].respuesta.subpregunta[
                                        subSIndex
                                      ].respuesta[campo.texto]
                                    "
                                  />
                                </div>
                              </template>
                            </template>
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                          <!-- /Subpregunta tipo multiselección->campos -->
                        </div>
                      </template>
                      <!-- /Subpreguntas de la pregunta multiselección -->
                      </div>
                    </div>
                    <!-- /pregunta tipo MULTISELECCION -->

                    <!-- pregunta tipo SELECCION_CONDICIONAL -->
                    <div v-if="question.tipo === 'SELECCION_CONDICIONAL'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <div class="relative">
                          <select
                            v-model="answers[index].respuesta.selected_answer"
                            :name="'question' + index"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          >
                            <option disabled selected>Seleccione una</option>
                            <template
                              v-for="(option, scOIndex) in question.opciones"
                            >
                              <option :key="'scO' + scOIndex" :value="option">
                                {{ option }}
                              </option>
                            </template>
                          </select>
                          <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                          >
                            <svg
                              class="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </div>
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Seleccione la respuesta.
                        </p>
                      </div>

                      <!-- preguntas condicionadas -->
                      <template
                        v-for="(
                          value, key, keyIndex
                        ) in question.pregunta_condicion"
                      >
                        <template
                          v-if="
                            answers[index].respuesta.selected_answer === key
                          "
                        >

                          <!-- pregunta condicionada tipo abierta -->
                          <div v-if="question.pregunta_condicion[key].tipo === 'ABIERTA'"
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'condQ' + keyIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <textarea
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              :id="'questionCond' + index"
                              type="text"
                              :name="'questionCond' + index"
                              v-model="
                                answers[index].respuesta.conditional_answer[key]
                                  .respuesta
                              "
                            />
                            <p
                              v-if="
                                answers[index].respuesta.conditional_answer[key]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </div>
                          <!-- /pregunta condicionada tipo abierta -->

                          <!-- pregunta condicionada multiselección -->
                          <div v-if="question.pregunta_condicion[key].tipo ==='MULTISELECCION'"
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'condQ' + keyIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <p
                              v-if="
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              "
                              class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                            >
                              {{
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              }}
                            </p>
                            <template
                              v-for="(option, scMOIndex) in question
                                .pregunta_condicion[key].opciones"
                            >
                              <div
                                class="flex items-center text-gray-700 font-bold"
                                :class="
                                  scMOIndex ===
                                    question.pregunta_condicion[key].opciones
                                      .length -
                                      1 &&
                                  !question.pregunta_condicion[key].otro
                                    ? 'mb-3'
                                    : ''
                                "
                                :key="'scM' + scMOIndex"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].respuesta.opciones[option]
                                  "
                                />
                                <span class="text-sm">
                                  {{ option }}
                                </span>
                              </div>
                            </template>
                            <div
                              v-if="question.pregunta_condicion[key].otro"
                              class="flex items-center text-gray-700 font-bold mb-3"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="checkbox"
                              />
                              <span class="text-sm"> Otro </span>
                              <input
                                type="text"
                                class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                                v-model="
                                  answers[index].respuesta.conditional_answer[
                                    key
                                  ].respuesta.otro
                                "
                              />
                            </div>
                          </div>
                          <!-- /pregunta condicionada multiselección -->

                          <!-- pregunta condicionada tipo selección -->
                          <div v-if="question.pregunta_condicion[key].tipo ==='SELECCION' "
                            :key="'condQ' + keyIndex"
                            class="w-full px-3 mb-6 md:mb-0"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <p
                              v-if="
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              "
                              class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                            >
                              {{
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              }}
                            </p>
                            <div class="relative">
                              <select
                                v-model="
                                  answers[index].respuesta.conditional_answer[
                                    key
                                  ].respuesta
                                "
                                :name="'questionCond' + index"
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              >
                                <option disabled selected>
                                  Seleccione una
                                </option>
                                <template
                                  v-for="(option, condOIndex) in question
                                    .pregunta_condicion[key].opciones"
                                >
                                  <option
                                    :key="'condO' + condOIndex"
                                    :value="option"
                                  >
                                    {{ option }}
                                  </option>
                                </template>
                              </select>
                              <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <!-- /pregunta condicionada tipo selección -->

                          <!-- pregunta condicionada tipo campos -->
                          <div v-if="question.pregunta_condicion[key].tipo === 'CAMPOS'"
                            :key="'condQ' + keyIndex"
                            class="w-full px-3 mb-6 md:mb-0"
                          >
                            <template
                              v-for="(campo, condFieldIndex) in question
                                .pregunta_condicion[key].campos"
                            >
                              <template v-if="campo.tipo === 'texto'">
                                <div :key="'condf' + condFieldIndex">
                                  <label
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                    :for="'condField' + condFieldIndex"
                                    >{{ campo.texto }}</label
                                  >
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    :id="'condField' + condFieldIndex"
                                    type="text"
                                    :name="'condField' + condFieldIndex"
                                    v-model="
                                      answers[index].respuesta
                                        .conditional_answer[key].respuesta[
                                        campo.texto
                                      ]
                                    "
                                  />
                                </div>
                              </template>
                            </template>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </div>
                          <!-- /pregunta condicionada tipo campos -->

                        </template>
                        <template
                          v-if="
                            answers[index].respuesta.selected_answer === key
                          "
                        >
                          <template
                            v-for="(subpregunta, subQIndex) in question
                              .pregunta_condicion[key].subpregunta"
                          >
                            <div
                              v-if="subpregunta.tipo === 'SELECCION'"
                              :key="'subCondQ' + subQIndex"
                              class="w-full px-3 mb-6 md:mb-0"
                            >
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'subCondQ' + subQIndex"
                                >{{ subpregunta.id_pregunta }}.-
                                {{ subpregunta.texto }}</label
                              >
                              <p
                                v-if="subpregunta.nota_para_registrante"
                                class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                              >
                                {{ subpregunta.nota_para_registrante }}
                              </p>
                              <div class="relative">
                                <select
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].subpregunta[subQIndex].respuesta
                                  "
                                  :name="'subCondQ' + subQIndex"
                                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                >
                                  <option disabled selected>
                                    Seleccione una
                                  </option>
                                  <template
                                    v-for="(
                                      option, subCondOptIndex
                                    ) in subpregunta.opciones"
                                  >
                                    <option
                                      :key="'subCondOpt' + subCondOptIndex"
                                      :value="option"
                                    >
                                      {{ option }}
                                    </option>
                                  </template>
                                </select>
                                <div
                                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                                >
                                  <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                      </template>
                      <!-- /preguntas condicionadas -->
                    </div>
                    <!-- /pregunta tipo SELECCION_CONDICIONAL -->

                    <!-- pregunta tipo SELECCION -->
                    <div v-if="question.tipo === 'SELECCION'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <div class="relative">
                          <select
                            v-model="answers[index].respuesta.selected_answer"
                            :name="'question' + index"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          >
                            <option disabled selected>Seleccione una</option>
                            <template
                              v-for="(option, sOIndex) in question.opciones"
                            >
                              <option :key="'sO' + sOIndex" :value="option">
                                {{ option }}
                              </option>
                            </template>
                            <option v-if="question.otro==true" value="Otro">
                              Otro
                            </option>
                          </select>
                          <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                          >
                            <svg
                              class="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          v-if="
                            answers[index].respuesta.selected_answer === 'Otro'
                          "
                          class="flex items-center text-gray-700 font-bold mb-3"
                        >
                          <span class="text-sm"> Otro </span>
                          <input
                            type="text"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Seleccione la respuesta.
                        </p>
                      </div>

                      <!-- subpreguntas de la pregunta de selección -->
                        <template
                        v-for="(subpregunta, subSIndex) in question.subpregunta"
                        >
                        <div
                          class="w-full px-3 mb-6 md:mb-0"
                          :key="'subS' + subSIndex"
                        >
                          <label
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                            :for="'subquestion' + subSIndex"
                            >{{ subpregunta.id_pregunta }}.-
                            {{ subpregunta.texto }}</label
                          >
                           <!-- Subpregunta tipo selección->abierta -->
                          <template v-if="subpregunta.tipo === 'ABIERTA'">
                            <textarea
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              :id="'subquestion' + subSIndex"
                              type="text"
                              :name="'subquestion' + subSIndex"
                              v-model="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .respuesta
                              "
                            />
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                          <!-- /Subpregunta tipo selección->abierta -->

                          <!-- Subpregunta tipo selección->selección -->
                          <template v-if="subpregunta.tipo === 'SELECCION'">
                            <div class="relative">
                              <select
                                v-model="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].respuesta.selected_answer
                                "
                                :name="'subquestion' + subSIndex"
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              >
                                <option disabled selected>
                                  Seleccione una
                                </option>
                                <template
                                  v-for="(
                                    option, subOIndex
                                  ) in subpregunta.opciones"
                                >
                                  <option
                                    :key="'subO' + subOIndex"
                                    :value="option"
                                  >
                                    {{ option }}
                                  </option>
                                </template>
                              </select>
                              <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Seleccione la respuesta.
                            </p>
                          </template>
                          <!-- /Subpregunta tipo selección->selección -->

                          <!-- Subpregunta tipo selección->campos -->
                          <template v-if="subpregunta.tipo === 'CAMPOS'">
                            <template
                              v-for="(
                                campo, subFieldIndex
                              ) in subpregunta.campos"
                            >
                              <template v-if="campo.tipo === 'texto'">
                                <div :key="'subf' + subFieldIndex">
                                  <label
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                    :for="'subquestionField' + subFieldIndex"
                                    >{{ campo.texto }}</label
                                  >
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    :id="'subquestionField' + subFieldIndex"
                                    type="text"
                                    :name="'subquestionField' + subFieldIndex"
                                    v-model="
                                      answers[index].respuesta.subpregunta[
                                        subSIndex
                                      ].respuesta[campo.texto]
                                    "
                                  />
                                </div>
                              </template>
                            </template>
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                          <!-- /Subpregunta tipo selección->campos -->
                        </div>
                        </template>
                        <!-- /subpreguntas de la pregunta de selección -->
                    </div>
                    <!-- /pregunta tipo SELECCION -->

                    <!-- pregunta tipo CAMPOS -->
                    <div v-if="question.tipo === 'CAMPOS'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>

                        <template
                          v-for="(campo, fieldIndex) in question.campos"
                        >
                          <template v-if="campo.tipo === 'texto'">
                            <div :key="'f' + fieldIndex">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'questionField' + fieldIndex"
                                >{{ campo.texto }}</label
                              >
                              <input
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                :id="'questionField' + fieldIndex"
                                type="text"
                                :name="'questionField' + fieldIndex"
                                v-model="answers[index].respuesta[campo.texto]"
                              />
                            </div>
                          </template>
                        </template>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
<!--                         <div class="w-full px-3 mb-3">
                          <label class="w-full flex items-center text-gray-900">
                            <input
                              class="mr-2 leading-tight"
                              type="checkbox"
                              v-model="answers[index].sensible"
                            />
                            <span class="text-sm">
                              Contiene información sensible
                            </span>
                          </label>
                        </div> -->
                      </div>
                    </div>
                    <!-- /pregunta tipo CAMPOS -->


                  </div>
                </div>
              </div>
              <!-- /Formulario de ficha -->

              <div class="flex w-full justify-end">
                <button
                  class="ml-2 bg-red-500 hover:bg-danger-color px-4 py-2 text-center rounded-lg text-white tracking-wide"
                  @click="close()"
                >
                  Cerrar
                </button>
                <button
                  class="ml-2 bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveLevantamiento()"
                >
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Levantamiento guardado correctamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="closeModal()"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error.</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-red"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

  </div>
</template>
<script>
import AlertDialog from "./AlertDialog";
import EventBus from "../event-bus";

export default {
  name: 'user-raising-update-questions-modal',
  data() {
    return {
      raising: null,
      categories: [],
      questions: [],
      answers: [],
      errors: {
        codeError: "Ha ocurrido un error",
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
  },
  mounted() {
    EventBus.$on("updateQuestionsModal", this.setData);
  },
  components: {
    AlertDialog,
  },
  methods: {
    reset: function () {
      this.raising = null;
      this.questions = [];
      this.answers = [];
      this.errors = {
        codeError: "Ha ocurrido un error",
      };
      //this.showingSuccess = false;
      this.showingError = false;
    },
    closeModal(){
      this.showingSuccess = false;
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    setData(raising) {
      this.raising = Object.assign({}, raising);
      if(this.raising.id_project){
        this.fetchProjectQuestions();
      }else{
        this.fetchQuestions();
      }
    },
    fetchQuestions() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getFichaPreguntas",
          {
            id_cat_principal: this.raising.id_cat_principal,
            existente: true,
          },
          this.config
        )
        .then((response) => {
          this.questions = response.data.questions;

          this.formatQuestions();

          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchProjectQuestions() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/projects/getFichaRespuestasJson",
          {
            id_project: this.raising.id_project,
          },
          this.config
        )
        .then((response) => {
          this.questions = response.data.answers;

          this.formatQuestions();

          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    formatQuestions() {
      this.answers = [];
      console.log(this.questions)
      console.log(this.raising.curret_questions)
      this.questions.forEach((question) => {
        let answer;
        let found_answer = this.raising.curret_questions.find((answer)=> answer.id_pregunta === question.id_pregunta);

        switch (question.tipo) {
          case "ABIERTA":
            //listo
            answer = found_answer ? found_answer.respuesta : "";
            break;
          case "MULTISELECCION":
            console.log("found_answer", found_answer)
            answer = {
                opciones: {},
            };

            if(found_answer){
              answer['opciones'] = found_answer.respuesta.opciones
              answer["otro"] = found_answer.respuesta["otro"];
              /* answer["otro"] = found_answer.respuesta.opciones["otro"]; */
            }
            else{
              question.opciones.forEach((option) => {
                answer.opciones[option] = false;
              });
              if (question.otro) {
                answer["otro"] = "";
              }  

            }
            console.log("answer", answer)


/*             if (question["subpregunta"] && question["subpregunta"].length>0) {
              answer["subpregunta"] = {};
              answer["subpregunta"]["id_pregunta"] =
                question["subpregunta"][0].id_pregunta;
              answer["subpregunta"]["texto"] = question["subpregunta"][0].texto;
              answer["subpregunta"]["tipo"] = question["subpregunta"][0].tipo;
              answer["subpregunta"]["respuesta"] = {};
              if (question["subpregunta"][0].tipo == "CAMPOS") {
                answer["subpregunta"]["sensible"] = false;
                question["subpregunta"][0].campos.forEach((field) => {
                  answer["subpregunta"]["respuesta"][field.texto] = "";
                });
              }
            } */
            if (question["subpregunta"] && question["subpregunta"].length>0) {
              if (question["subpregunta"].length > 0) {
                answer["subpregunta"] = [];
                question["subpregunta"].forEach((question) => {
                  let subAnswer = {
                    respuesta: null,
                  };
                  subAnswer.id_pregunta = question.id_pregunta;
                  subAnswer.texto = question.texto;
                  subAnswer.tipo = question.tipo;

                  let found_subAnswer;
                  if(found_answer){
                    found_subAnswer = found_answer.respuesta.subpregunta.find((answer)=> answer.id_pregunta === question.id_pregunta);
                  }

                  if(found_subAnswer){
                    subAnswer.respuesta = found_subAnswer.respuesta;
                  }else{
                    if (question.tipo === "ABIERTA") {
                      subAnswer.respuesta = "";
                    }
  
                    if (question.tipo === "SELECCION") {
                      subAnswer.respuesta = {
                        selected_answer: "",
                      };
                    }
  
                    if (question.tipo === "CAMPOS") {
                      subAnswer.respuesta = {};
  
                      question.campos.forEach((campo) => {
                        subAnswer.respuesta[campo.texto] = "";
                      });
                    }
                  }

                  subAnswer.error = false;

                  answer["subpregunta"].push(subAnswer);
                });
              }
            }
            break;
          case "MULTISELECCION_CATEGORIAS":
            answer = {};
            if (question["otro"] == true) {
              answer["otro"] = "";
            }
            answer["categorias"] = {};
            question.categorias.forEach((categoria) => {
              answer["categorias"][categoria.categoria_nombre] = {};
              categoria.opciones.forEach((opcion) => {
                answer["categorias"][categoria.categoria_nombre][
                  opcion
                ] = false;
              });
            });
            break;
          case "SELECCION_CONDICIONAL":
            //LISTO
            answer = {};
            answer["selected_answer"] = found_answer ? found_answer.respuesta.selected_answer : "";
            answer["conditional_answer"] = {};

            Object.entries(question.pregunta_condicion).forEach(
              ([key, value]) => {
                answer["conditional_answer"][key] = {};
                answer["conditional_answer"][key]["id"] = value["id"];
                answer["conditional_answer"][key]["tipo"] = value["tipo"];
                answer["conditional_answer"][key]["texto"] = value["texto"];

                if(found_answer){
                  if(found_answer.respuesta.conditional_answer.hasOwnProperty(key)) {
                    answer["conditional_answer"][key]["respuesta"]  = found_answer.respuesta.conditional_answer[key]['respuesta'];
                    if(value["tipo"] == "ABIERTA" || value["tipo"] == "CAMPOS"){
                      answer["conditional_answer"][key]["sensible"] = found_answer.respuesta.conditional_answer[key]['sensible'];
                    }

                    if(value["tipo"] == "MULTISELECCION"){
                      if(found_answer.respuesta.conditional_answer[key]['respuesta']['otro'] != ''){
                        answer["conditional_answer"][key]["respuesta"]["checked_otro"] = true
                      }
                    }
                    if(found_answer.respuesta.conditional_answer[key]['subpregunta']){
                      answer["conditional_answer"][key]["subpregunta"] = found_answer.respuesta.conditional_answer[key]['subpregunta'];
                    }else{
                      if (question.pregunta_condicion[key].subpregunta) {
                        let subAnswers = [];
                        question.pregunta_condicion[key].subpregunta.forEach(
                          (subpregunta) => {
                            let subAnswer = {
                              id_pregunta: subpregunta.id_pregunta,
                              texto: subpregunta.texto,
                              tipo: subpregunta.tipo,
                              respuesta: "",
                            };
                            subAnswers.push(subAnswer);
                          }
                        );

                        answer["conditional_answer"][key].subpregunta = subAnswers;
                      }
                    }
                  }else{
                    if (value["tipo"] == "ABIERTA") {
                      answer["conditional_answer"][key]["respuesta"] = "";
                    }

                    if (value["tipo"] == "MULTISELECCION") {
                      answer["conditional_answer"][key]["respuesta"] = {};

                      answer["conditional_answer"][key]["respuesta"]["opciones"] =
                        {};
                      value["opciones"].forEach((opcion) => {
                        answer["conditional_answer"][key]["respuesta"]["opciones"][
                          opcion
                        ] = false;
                      });

                      if (value["otro"] == true) {
                        answer["conditional_answer"][key]["respuesta"]["otro"] = "";
                      }
                    }
                    if (value["tipo"] == "MULTISELECCION_CATEGORIAS") {
                      answer["conditional_answer"][key]["respuesta"] = {};
                      answer["conditional_answer"][key]["respuesta"]["categorias"] =
                        {};
                      value["categorias"].forEach((categoria) => {
                        answer["conditional_answer"][key]["respuesta"][
                          "categorias"
                        ][categoria.categoria_nombre] = {};
                        categoria.opciones.forEach((opcion) => {
                          answer["conditional_answer"][key]["respuesta"][
                            "categorias"
                          ][categoria.categoria_nombre][opcion] = false;
                        });
                      });
                      if (value["otro"] == true) {
                        answer["conditional_answer"][key]["respuesta"]["otro"] = "";
                      }
                    }

                    if (value["tipo"] == "SELECCION") {
                      answer["conditional_answer"][key]["respuesta"] = "";
                    }

                    if (value["tipo"] === "CAMPOS") {
                      answer["conditional_answer"][key]["respuesta"] = {};
                      question.pregunta_condicion[key].campos.forEach((field) => {
                        answer["conditional_answer"][key]["respuesta"][
                          field.texto
                        ] = "";
                      });
                    }

                    if (question.pregunta_condicion[key].subpregunta) {
                      let subAnswers = [];
                      question.pregunta_condicion[key].subpregunta.forEach(
                        (subpregunta) => {
                          let subAnswer = {
                            id_pregunta: subpregunta.id_pregunta,
                            texto: subpregunta.texto,
                            tipo: subpregunta.tipo,
                            respuesta: "",
                          };
                          subAnswers.push(subAnswer);
                        }
                      );

                      answer["conditional_answer"][key].subpregunta = subAnswers;
                    }
                  }
                }

                answer["conditional_answer"][key]["error"] = false;
              }
            );
            break;
          case "SELECCION":
            //En proceso            
            answer = {};

            if (question.otro) {
              answer["otro"] = found_answer ? found_answer.respuesta.otro : "";
            }

            answer["selected_answer"] = found_answer ? found_answer.respuesta.selected_answer : "";

            if (question["subpregunta"] && question["subpregunta"].length>0) {
              if (question["subpregunta"].length > 0) {
                answer["subpregunta"] = [];
                question["subpregunta"].forEach((question) => {
                  let subAnswer = {
                    respuesta: null,
                  };
                  subAnswer.id_pregunta = question.id_pregunta;
                  subAnswer.texto = question.texto;
                  subAnswer.tipo = question.tipo;

                  let found_subAnswer;
                  if(found_answer){
                    found_subAnswer = found_answer.respuesta.subpregunta.find((answer)=> answer.id_pregunta === question.id_pregunta);
                  }

                  if(found_subAnswer){
                    subAnswer.respuesta = found_subAnswer.respuesta;
                  }else{
                    if (question.tipo === "ABIERTA") {
                      subAnswer.respuesta = "";
                    }
  
                    if (question.tipo === "SELECCION") {
                      subAnswer.respuesta = {
                        selected_answer: "",
                      };
                    }
  
                    if (question.tipo === "CAMPOS") {
                      subAnswer.respuesta = {};
  
                      question.campos.forEach((campo) => {
                        subAnswer.respuesta[campo.texto] = "";
                      });
                    }
                  }

                  subAnswer.error = false;

                  answer["subpregunta"].push(subAnswer);
                });
              }
            }
            break;
          case "CAMPOS":
            answer = found_answer ? found_answer.respuesta : {};
            break;
          default:
            break;
        }

        this.answers.push({
          id_pregunta: question.id_pregunta,
          texto: question.texto,
          tipo: question.tipo,
          respuesta: answer,
          obligatoria: question.obligatoria,
          sensible: found_answer ? found_answer.sensible : false,
          error: false,
        });
      });
    },
    saveLevantamiento() {
      //console.log(this.answers)

      if (this.answers.length > 0) {
        let validQuestions = false 
        if (this.raising.editQuestion == true){
          validQuestions = true;
        }else{
          validQuestions = this.validateAnswers();
        }

        if (validQuestions) {
          this.$root.$emit("showLoading");
          let request = {};
          let userAnswers = {};

          this.answers.forEach((answer) => {
            delete answer.error;
            if (answer.tipo === "SELECCION_CONDICIONAL") {
              let user_answer = {};
              for (let key in answer.respuesta.conditional_answer) {
                if (key === answer.respuesta.selected_answer) {
                  delete answer.respuesta.conditional_answer[key].error;
                  user_answer[key] = answer.respuesta.conditional_answer[key];
                }
              }

              answer.respuesta.conditional_answer = user_answer;
            }

            if (answer.tipo === "SELECCION") {
              if (answer.respuesta.selected_answer !== "Otro") {
                answer.respuesta.otro = "";
              }

              if (answer.respuesta.subpregunta) {
                if (answer.respuesta.subpregunta.length > 0) {
                  answer.respuesta.subpregunta.forEach((subpregunta) => {
                    delete subpregunta.error;
                  });
                }
              }
            }
          });

          this.questions.forEach((question, index) => {
            userAnswers[question.id_pregunta] = this.answers[index];
          });

          request = {
            id: this.raising.id,
            id_cat_principal: this.raising.id_cat_principal,
            id_usuario: localStorage.getItem("user_id"),
            registro: null,
            respuestas: userAnswers,
          };


          this.axios
            .put("../apidev/levantamientos/updatePreguntas", request, this.config)
            .then(() => {
              this.$root.$emit("hideLoading");
              this.showingSuccess = true;
              this.$emit('updateQuestions');
              this.close();
            })
            .catch((error) => this.catchError(error) );
        }
        
      }else{
        this.close();
      }
      
    },
    validateAnswers() {
      let requiredAnswers = this.answers.filter((answer) => answer.obligatoria);

      let isValid = true;

      requiredAnswers.forEach((answer) => {
        switch (answer.tipo) {
          case "ABIERTA":
            if (answer.respuesta === "") {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
            }
            break;
          case "SELECCION":
            if (answer.respuesta.selected_answer === "") {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
            }

            if (answer.respuesta.subpregunta) {
              answer.respuesta.subpregunta.forEach((subpregunta) => {
                if (subpregunta.tipo === "ABIERTA") {
                  if (subpregunta.respuesta === "") {
                    isValid = false;
                    subpregunta.error = true;
                  } else {
                    subpregunta.error = false;
                  }
                }

                if (subpregunta.tipo === "SELECCION") {
                  if (subpregunta.respuesta.selected_answer === "") {
                    isValid = false;
                    subpregunta.error = true;
                  } else {
                    subpregunta.error = false;
                  }
                }

                if (subpregunta.tipo === "CAMPOS") {
                  let haveEmpty = false;
                  for (let key in subpregunta.respuesta) {
                    if (subpregunta.respuesta[key] === "") {
                      haveEmpty = true;
                      isValid = false;
                      subpregunta.error = true;
                    }
                  }

                  if (!haveEmpty) {
                    subpregunta.error = false;
                  }
                }
              });
            }

            break;
          case "SELECCION_CONDICIONAL":
            if (answer.respuesta.selected_answer === "") {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
              if (
                answer.respuesta.conditional_answer[
                  answer.respuesta.selected_answer
                ]
              ) {
                if (
                  answer.respuesta.conditional_answer[
                    answer.respuesta.selected_answer
                  ].respuesta === ""
                ) {
                  isValid = false;
                  answer.respuesta.conditional_answer[
                    answer.respuesta.selected_answer
                  ].error = true;
                } else {
                  answer.respuesta.conditional_answer[
                    answer.respuesta.selected_answer
                  ].error = false;
                }
              }
            }
            break;
          case "CAMPOS": {
            let haveEmpty = false;
            for (let key in answer.respuesta) {
              if (answer.respuesta[key] === "") {
                haveEmpty = true;
                isValid = false;
                answer.error = true;
              }
            }

            if (!haveEmpty) {
              answer.error = false;
            }
            break;
          }
          default:
            break;
        }
      });

      return isValid;
    },
    catchError(error){
      console.log("data", error)
      this.$root.$emit("hideLoading");
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
    }
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
